export default "__VITE_ASSET__e824183e__"